import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';
import { BootstrapQuery } from '~/layouts/AppLayout/useBootstrapQuery';

const CreateSchoolYearMutation = graphql.persisted(
  "CreateSchoolYear",
  graphql(`
    mutation CreateSchoolYear(
      $schoolId: ID!
      $name: String!
      $administrativeStartDate: ISO8601Date!
      $administrativeEndDate: ISO8601Date!
      $reenrollmentStartDate: ISO8601Date
      $openEnrollmentStartDate: ISO8601Date
    ) {
      createSchoolYear(input: {
        schoolId: $schoolId
        name: $name
        administrativeStartDate: $administrativeStartDate
        administrativeEndDate: $administrativeEndDate
        reenrollmentStartDate: $reenrollmentStartDate
        openEnrollmentStartDate: $openEnrollmentStartDate
      }) {
        school {
          id
          schoolYears {
            id
            name
            slug
          }
        }
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export function useCreateSchoolYear() {
  return useMutation(CreateSchoolYearMutation, {
    refetchQueries: [{ query: BootstrapQuery }],
  });
}
